{
  "aiGeneratedAnswer": "Resposta Gerada por IA",
  "allCategories": "Todas as Categorias",
  "appliedFiltersToCurrentSearch": "Filtros aplicados à pesquisa atual",
  "apply": "Aplicar",
  "applyFilters": "Aplicar Filtros",
  "autocompleteOptionsFound_one": "{{count}}{{label}} opção de preenchimento automático encontrada.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} opções de preenchimento automático encontradas.",
  "autocompleteSuggestion": "sugestão de preenchimento automático: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} sugestão de preenchimento automático encontrada.",
  "autocompleteSuggestionsFound_other": "{{count}} sugestões de preenchimento automático encontradas.",
  "basedOnYourDevice": " (baseado no seu dispositivo)",
  "basedOnYourInternetAddress": " (baseado no seu endereço de internet)",
  "categoriesText_one": "A seguinte categoria apresentou resultados para - <strong>{{query}}</strong>",
  "categoriesText_other": "As seguintes categorias apresentaram resultados para - <strong>{{query}}</strong>",
  "clearAll": "Limpar Tudo",
  "clearMinAndMax": "Limpar mín e máx",
  "clearTheRangeToSelectOptions": "Limpar o intervalo para selecionar opções.",
  "clearTheSearchBar": "Limpar a barra de pesquisa",
  "conductASearch": "Realizar uma busca",
  "currentLocation": "Localização Atual",
  "didYouMean": "Você quis dizer <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Quando os resultados de preenchimento automático estiverem disponíveis, use as setas para cima e para baixo para revisar e Enter para selecionar.",
  "feedback": "Feedback",
  "invalidRange": "Intervalo inválido",
  "max": "Máx",
  "min": "Mín",
  "navigateToTheNextResultsPage": "Navegar para a próxima página de resultados",
  "navigateToThePreviousResultsPage": "Navegar para a página de resultados anterior",
  "noAutocompleteOptionsFound": "0 opções de preenchimento automático encontradas.",
  "noAutocompleteSuggestionsFound": "0 sugestões de preenchimento automático encontradas.",
  "noResultsFoundIn": "Nenhum resultado encontrado em {{currentVerticalLabel}}.",
  "pagination": "Paginação",
  "readMoreAbout": "Leia mais sobre <a>{{name}}</a>",
  "recentSearch": "busca recente: {{query}}",
  "recentSearchesFound_one": "{{count}} busca recente encontrada.",
  "recentSearchesFound_other": "{{count}} buscas recentes encontradas.",
  "removeFilter": "Remover filtro «{{displayName}}»",
  "resultPreview": "pré-visualização do resultado: {{value}}",
  "resultPreviewsFound_one": "{{count}} pré-visualização do resultado encontrada.",
  "resultPreviewsFound_other": "{{count}} pré-visualizações recentes encontradas.",
  "resultsCountText_one": "{{count}} Resultado",
  "resultsCountText_other": "{{count}} Resultados",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} de {{resultsCount}} Resultados",
  "searchHere": "Pesquise aqui…",
  "showLess": "Mostrar Menos",
  "showMore": "Mostrar Mais",
  "showingAllInstead": "Mostrando todos os {{currentVerticalLabel}} em vez disso.",
  "sources_one": "Fonte",
  "sources_other": "Fontes ({{count}})",
  "submitSearch": "Enviar pesquisa",
  "suggestionResultsCount_one": "{{label}} - {{count}} resultado",
  "suggestionResultsCount_other": "{{label}} - {{count}} resultados",
  "thankYouForYourFeedback": "Obrigado pelo seu feedback!",
  "thisAnsweredMyQuestion": "Isso respondeu à minha pergunta",
  "thisDidNotAnswerMyQuestion": "Isso não respondeu à minha pergunta",
  "unselectAnOptionToEnterInARange": "Desmarque uma opção para inserir um intervalo.",
  "updateYourLocation": "Atualize sua localização",
  "useCurrentLocation": "Usar Localização Atual",
  "useMyLocation": "Usar minha localização",
  "viewAll": "Ver tudo",
  "viewDetails": "Ver Detalhes"
}
